import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle } from 'react-icons/fa';
import Logo from './Logo';
import './LanguageModal.css';

const LanguageModal = ({ onClose }) => {
  const { i18n } = useTranslation();
  const [closing, setClosing] = useState(false);

  const languages = [
    {
      code: 'en',
      title: 'English',
      desc: 'Browse website in English'
    },
    {
      code: 'mr',
      title: 'मराठी',
      desc: 'मराठी भाषेमध्ये वेबसाईट पहा'
    },
    {
      code: 'kn',
      title: 'ಕನ್ನಡ',
      desc: 'ಕನ್ನಡ ಭಾಷೆಯಲ್ಲಿ ವೆಬ್‌ಸೈಟ್ ವೀಕ್ಷಿಸಿ'
    }
  ];

  const handleSelectLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('i18nextLng', code);
    setClosing(true);
    setTimeout(() => {
      if (onClose) onClose();
    }, 400);
  };

  return (
    <div className={`lang-modal-backdrop ${closing ? 'fade-out' : ''}`}>
      <div className={`lang-modal-card ${closing ? 'pop-down' : 'pop-up'}`}>
        <div className="lang-modal-header">
          <div className="lang-modal-logo-wrap">
            <Logo width="250px" height="72px" />
          </div>
          <h2>Select Your Preferred Language</h2>
          <p className="lang-modal-subtitle">
            आपली आवडती भाषा निवडा / ನಿಮ್ಮ ಆದ್ಯತೆಯ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ
          </p>
        </div>

        <div className="lang-modal-options">
          {languages.map((lang) => {
            const isSelected = i18n.language === lang.code;
            return (
              <button
                key={lang.code}
                className={`lang-option-btn ${isSelected ? 'active' : ''}`}
                onClick={() => handleSelectLanguage(lang.code)}
              >
                <div className="lang-option-left">
                  <div className="lang-text-group">
                    <span className="lang-title">{lang.title}</span>
                    <span className="lang-desc">{lang.desc}</span>
                  </div>
                </div>
                {isSelected && <FaCheckCircle className="lang-check-icon" />}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
